<template>
	<div ref="btn" :class="{'DropdownButton': true, open: isOpen, above: isFlyoutAbove, left: isFlyoutLeft}">
		<Button :data-uid="_uid" class="DropdownButton-button" @click="toggleDropdown">
			<slot name="button"></slot>
			<ChevronDownIcon :data-uid="_uid" class="DropdownButton-button-icon" />
		</Button>
		<div class="DropdownButton-options" ref="flyout">
			<slot />
		</div>
	</div>
</template>

<script>
	import Button from '@/components/Button';
	import { ChevronDownIcon } from 'vue-feather-icons';

	export default {
		components: {
			Button,
			ChevronDownIcon,
		},

		data() {
			return {
				isOpen: false,
				isFlyoutAbove: false,
				isFlyoutLeft: false,
				delayFn: null
			}
		},

		methods: {
			setDropdownPosition() {
				const rect = this.$refs.flyout.getBoundingClientRect();
				if (rect.width > 0) {
					this.isFlyoutAbove = rect.bottom >= window.innerHeight;
					this.isFlyoutLeft = rect.right >= window.innerWidth;
				}
			},

			openDropdown() {
				this.isOpen = true;
				this.setDropdownPosition();
				if (this.$store.state.activeDropdown) {
					this.$store.state.activeDropdown.closeDropdown();
				}
				this.$store.commit('setActiveDropdown', this);
			},

			closeDropdown() {
				this.isOpen = false;
				this.$store.commit('setActiveDropdown', null);
			},

			toggleDropdown() {
				clearTimeout(this.delayFn);
				if (this.isOpen) {
					this.closeDropdown();
				} else {
					this.openDropdown();
				}
			},
		}
	};
</script>
